/* eslint-disable no-undef */
import React, { useState } from 'react';
import { Styles } from './style';

interface OperationFilterProps {
  setSelectedOperation: (operation: 'ALUGUEL' | 'VENDA' | 'TODOS') => void;
}

const OperationFilter: React.FC<OperationFilterProps> = ({
  setSelectedOperation
}) => {
  const [selected, setSelected] = useState<'ALUGUEL' | 'VENDA' | 'TODOS'>(
    'TODOS'
  );

  const handleSelect = (operation: 'ALUGUEL' | 'VENDA' | 'TODOS') => {
    setSelected(operation);
    switch (operation) {
      case 'ALUGUEL':
        setSelectedOperation('ALUGUEL');
        break;
      case 'VENDA':
        setSelectedOperation('VENDA');
        break;
      case 'TODOS':
        setSelectedOperation('TODOS');
        break;
    }
  };

  return (
    <Styles.Container>
      <Styles.Button
        selected={selected === 'ALUGUEL'}
        onClick={() => handleSelect('ALUGUEL')}>
        Alugar
      </Styles.Button>

      <Styles.Button
        selected={selected === 'VENDA'}
        onClick={() => handleSelect('VENDA')}>
        Comprar
      </Styles.Button>

      <Styles.Button
        selected={selected === 'TODOS'}
        onClick={() => handleSelect('TODOS')}>
        Todos
      </Styles.Button>
    </Styles.Container>
  );
};

export default OperationFilter;
